import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const paths = {
    search: 'M21 21l-6-6 M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
    send: 'M22 2L9 15 M22 2l-7 20-4-9-9-4z',
    info: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0 M12 11v6 M12 7h.01',
    building: 'M6 22V3h12v19 M6 8H3v14h18V12h-3 M10 7h4 M10 11h4 M10 15h4 M10 19h4',
    wallet: 'M20 8V5a2 2 0 0 0-2-2H5a3 3 0 0 0 0 6h15v12H5a3 3 0 0 1-3-3V6 M20 12h-5v5h5 M16 14h.01',
    bank: 'M3 10h18 M3 22h18 M5 10v12 M10 10v12 M14 10v12 M19 10v12 M12 2L2 7v3h20V7z',
    bot: 'M12 3v3 M10 3h2 M5 8h14v12H5z M2 12v4 M22 12v4 M9 12v3 M15 12v3 M9 18h6',
    gift: 'M3 8h18v4H3z M5 12v10h14V12 M12 8v14 M12 8H8a3 3 0 1 1 3-3z M12 8h4a3 3 0 1 0-3-3z',
    checkCircle: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0 M8 12l3 3 5-6',
    arrowLeft: 'M19 12H5 M12 19l-7-7 7-7',
    users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M16 3a4 4 0 0 1 0 8 M22 21v-2a4 4 0 0 0-3-3.87 M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
    admission: 'M9 5H5v16h14V5h-4 M9 3h6v4H9z M9 12h6 M9 16h6',
    invite: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M20 8v6 M17 11h6',
    settings: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8 M9 2h6l1 3 3 1 3 5-2 2v3l-3 3-3-1-2 2-5-1-1-3-3-2 1-5 3-1z',
    receipt: 'M4 3l2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2v18l-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2z M8 9h8 M8 13h6',
    card: 'M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z M2 10h20',
    down: 'M22 17l-8-8-5 5-7-7 M16 17h6v-6',
    up: 'M22 7l-8 8-5-5-7 7 M16 7h6v6',
    sparkles: 'M12 3l2.7 6.3L21 12l-6.3 2.7L12 21l-2.7-6.3L3 12l6.3-2.7z M20 2v4 M18 4h4',
    bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9 M10 21h4',
    chevron: 'M9 5l7 7-7 7',
    warning: 'M12 3L2 21h20z M12 9v5 M12 17h.01',
    bulb: 'M9 18h6 M9 21h6 M9 15a6 6 0 1 1 6 0v3H9z',
    shield: 'M12 2l8 4v6c0 5-8 10-8 10S4 17 4 12V6z M12 8v5 M12 16h.01',
    help: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0 M9 9a3 3 0 1 1 5 2c-2 1-2 2-2 3 M12 17h.01',
};
export default function BpoIcon({ name, size = 16 }) {
    return (_jsx("svg", { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round', "aria-hidden": 'true', children: _jsx("path", { d: paths[name] }) }));
}
